var H = require("hogan.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("iFrameBlock",c,p,1),c,p,0,16,123,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <iframe src=\"");t.b(t.v(t.f("iFrameUrl",c,p,0)));t.b("\" width=\"");t.b(t.v(t.f("iFrameWidth",c,p,0)));t.b("\" height=\"");t.b(t.v(t.f("iFrameHeight",c,p,0)));t.b("\" frameborder=\"0\"></iframe>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#iFrameBlock}}\n  <iframe src=\"{{iFrameUrl}}\" width=\"{{iFrameWidth}}\" height=\"{{iFrameHeight}}\" frameborder=\"0\"></iframe>\n{{/iFrameBlock}}\n", H);return T; }();


//////////////////
// WEBPACK FOOTER
// ./web/views/dynamicblock-iframe.mustache
// module id = 726
// module chunks = 2